define(['app', 'jquery', './base'], function (app, $, Helper) {
  return Helper.extend({
    events: {
      click: 'quote'
    },

    quote: function (e) {
      if (this.options.isGuest) {
        app.events.commands.execute('modal:login:show')
      } else {
        if (window.CKEDITOR) {
          var postId = e.currentTarget.getAttribute('data-id')

          if (postId) {
            $.get('/post/getContentForQuote', { postid: e.currentTarget.getAttribute('data-id') }).then(function (data) {
              window.CKEDITOR.instances.editor1.execCommand('quote-user', {
                user: e.currentTarget.getAttribute('data-rel'),
                data: data.content
              })
            })
          } else {
            window.CKEDITOR.instances.editor1.execCommand('quote-user', {
              user: e.currentTarget.getAttribute('data-rel'),
              data: e.currentTarget.getAttribute('data-meta')
            })
          }
          e.preventDefault()
        } else {
          app.events.commands.execute('editor:bbcode:add', e)
        }
      }
    }
  })
})
